import type { Catalog } from '@smarton-pbx/shared';

/** The company's settings: General (calls, notifications, recording notice, transcription, AI call review), Carriers, Numbers, Branding, SmartOn. */
export const settings: Catalog = {
  // The tabs.
  General: 'Bendrieji',
  Carriers: 'Ryšio operatoriai',
  Branding: 'Įmonės išvaizda',
  'Your name, colours and logo, on every screen your people see.': 'Jūsų pavadinimas, spalvos ir logotipas visuose ekranuose, kuriuos mato jūsų darbuotojai.',

  // General: calls.
  'How calls ring, who is told about what, and how calls are transcribed and reviewed.':
    'Kaip skamba skambučiai, kas apie ką informuojamas ir kaip skambučiai transkribuojami bei vertinami.',
  'A call to someone’s number rings their browser and app.': 'Skambutis į darbuotojo numerį skamba jo naršyklėje ir programėlėje.',
  'If they don’t answer, it rings their mobile, showing your number.': 'Jei jis neatsiliepia, skambinama į jo mobilųjį telefoną, rodant jūsų numerį.',
  'If that isn’t answered either, the call goes where the person chose under “When I can’t answer” on their Account page: their voicemail (the default), a colleague or a queue. They can also be away for some days, or skipped while on a call.':
    'Jei ir ten neatsiliepiama, skambutis nukreipiamas ten, kur darbuotojas pasirinko savo paskyros puslapyje, skiltyje „Kai negaliu atsiliepti“: į jo balso paštą (numatyta), kolegai arba į eilę. Jis taip pat gali nurodyti, kad kelias dienas jo nebus, arba kad skambučiai jį praleistų, kol jis kalba kitu skambučiu.',
  'Ring browser and app': 'Skambinti naršyklėje ir programėlėje',
  Seconds: 'Sekundės',
  'Then ring the mobile': 'Tada skambinti į mobilųjį',
  'Wait for a closed app': 'Laukti uždarytos programėlės',
  'Seconds. If nobody’s app is connected, the call waits this long for one to come online':
    'Sekundės. Jei nė viena programėlė neprisijungusi, skambutis tiek laukia, kol kuri nors prisijungs',
  'Longest call': 'Ilgiausias skambutis',
  'Minutes. Calls are ended after this, to limit runaway costs': 'Minutės. Po tiek laiko skambučiai baigiami, kad neišaugtų išlaidos',
  'Calls at once, per person': 'Skambučių vienu metu darbuotojui',
  'Calls out beyond this are refused': 'Viršijus šį skaičių, skambučiai į išorę atmetami',
  'Minutes out per day, per person': 'Minučių į išorę per dieną darbuotojui',
  'Then calls out stop until tomorrow, and admins are told. The company’s own limits are set by your provider.':
    'Tada skambučiai į išorę sustabdomi iki rytojaus, o administratoriams pranešama. Visos įmonės ribas nustato jūsų paslaugų teikėjas.',
  'Ask people to press 1 when they answer on their mobile': 'Prašyti paspausti 1, kai atsiliepiama mobiliuoju telefonu',
  'Recommended. Without it, a mobile’s own voicemail can pick up the call, and the caller ends up there instead of yours.':
    'Rekomenduojama. Be šio nustatymo skambutį gali priimti paties mobiliojo telefono balso paštas, ir skambinantysis pateks ten, o ne į jūsų balso paštą.',

  // General: notifications.
  'What people are told about unless they choose otherwise on their account page. Carrier and blocked-call alerts go to admins.':
    'Apie ką informuojami darbuotojai, nebent jie savo paskyros puslapyje pasirinktų kitaip. Pranešimai apie ryšio operatorius ir užblokuotus skambučius siunčiami administratoriams.',
  'Show the caller’s number in notifications on the computer': 'Rodyti skambinančiojo numerį kompiuterio pranešimuose',
  'These can be seen on a locked screen. Off: they only say “Missed call” or “Incoming call”.':
    'Juos galima matyti ir užrakintame ekrane. Išjungus juose rašoma tik „Praleistas skambutis“ arba „Įeinantis skambutis“.',

  // General: recording notice (the three choices are also on the Regions page).
  'No notice': 'Be įspėjimo',
  'Announced to the other party': 'Pranešama pašnekovui',
  'Reminder to staff': 'Priminimas darbuotojams',
  'Recording notice': 'Įspėjimas apie įrašymą',
  'Each region chooses its notice on the {regions} page: none, an announcement the other party hears when the call starts, or a reminder to staff on every call.':
    'Kiekvienas regionas įspėjimą pasirenka puslapyje {regions}: jokio, garso įspėjimas, kurį pašnekovas išgirsta skambučio pradžioje, arba priminimas darbuotojams per kiekvieną skambutį.',
  Wording: 'Formuluotė',
  'e.g. This call may be recorded and analysed to improve our service.': 'pvz., Šis pokalbis gali būti įrašomas ir analizuojamas, kad galėtume gerinti savo paslaugas.',
  'Shown to staff as the reminder, and the script for whoever records the announcement.':
    'Rodoma darbuotojams kaip priminimas; tai ir tekstas tam, kas įrašinės garso įspėjimą.',
  'Save wording': 'Išsaugoti formuluotę',
  Announcements: 'Garso įspėjimai',
  'Use a file under 5 MB.': 'Naudokite mažesnį nei 5 MB failą.',
  // {language}: a language's name ("lietuvių").
  '{language} announcement': 'Garso įspėjimas {language} kalba',
  'Converting…': 'Konvertuojama…',
  'That file couldn’t be used.': 'Šio failo panaudoti nepavyko.',
  'None yet': 'Dar nėra',
  'Remove the {language} announcement': 'Pašalinti garso įspėjimą {language} kalba',
  'A short recording (a few seconds) in WAV, MP3, OGG or M4A. Each region plays the one in its main language, or else in another of its languages.':
    'Trumpas (kelių sekundžių) įrašas WAV, MP3, OGG arba M4A formatu. Kiekvienas regionas paleidžia įspėjimą savo pagrindine kalba, o jei tokio nėra – kita savo kalba.',
  '{region} is set to announce, but there’s no announcement in {languages} yet, so callers there hear nothing.':
    '{region}: nustatyta paleisti garso įspėjimą, bet dar nėra įspėjimo {languages} kalba, todėl ten skambinantieji nieko neišgirsta.',

  // General: transcription.
  Transcription: 'Transkribavimas',
  'Transcribe calls': 'Transkribuoti skambučius',
  'On this server (recordings stay here)': 'Šiame serveryje (įrašai lieka čia)',
  'With a hosted service': 'Išorine paslauga',
  'Recordings are sent to this service to be transcribed, so they leave your server. It must offer an OpenAI-compatible transcription API.':
    'Įrašai siunčiami transkribuoti į šią paslaugą, todėl jie palieka jūsų serverį. Paslauga turi siūlyti su OpenAI suderinamą transkribavimo API.',
  'Service address': 'Paslaugos adresas',
  Model: 'Modelis',
  'OpenAI: whisper-1. Groq: whisper-large-v3 or whisper-large-v3-turbo': 'OpenAI: whisper-1. Groq: whisper-large-v3 arba whisper-large-v3-turbo',
  'API key': 'API raktas',
  'Leave empty to keep the current one': 'Palikite tuščią, kad liktų dabartinis',
  'Never shown again': 'Daugiau niekada nerodomas',
  'Names and terms to spell right': 'Teisingai rašomi pavadinimai ir terminai',
  'Your brand, products, partners and local words. Passed to Whisper as a hint; models tuned for one language (like agirdi) get none, as a hint garbles what they write.':
    'Jūsų prekės ženklas, produktai, partneriai ir vietiniai žodžiai. Perduodami Whisper kaip užuomina; vienai kalbai pritaikyti modeliai (pvz., agirdi) jos negauna, nes dėl užuominos jie užrašo nesąmones.',
  'Type a name and press Enter': 'Įveskite pavadinimą ir paspauskite Enter',
  'Add a name or term': 'Pridėti pavadinimą ar terminą',
  'For every language; each transcript says which model made it. A new model downloads on first use.':
    'Visoms kalboms; kiekvienoje transkripcijoje nurodyta, kuris modelis ją sukūrė. Naujas modelis atsisiunčiamas, kai panaudojamas pirmą kartą.',
  'Server default ({model})': 'Serverio numatytasis ({model})',
  'Another model…': 'Kitas modelis…',
  'Model name': 'Modelio pavadinimas',
  'A faster-whisper name, a Hugging Face repository in CTranslate2 format, or a folder in the server’s models (/models/…)':
    'faster-whisper pavadinimas, Hugging Face saugykla CTranslate2 formatu arba aplankas serverio modeliuose (/models/…)',
  'e.g. medium': 'pvz., medium',
  // The models' descriptions (shared WHISPER_MODELS, shown with t(label)).
  'large-v3: most accurate of OpenAI’s': 'large-v3: tiksliausias iš OpenAI modelių',
  'turbo: several times faster, a little less accurate': 'turbo: kelis kartus greitesnis, šiek tiek mažiau tikslus',
  'large-v2: older, sometimes better on some recordings': 'large-v2: senesnis, kai kuriems įrašams kartais geresnis',
  'medium: faster, clearly weaker for Lithuanian': 'medium: greitesnis, lietuvių kalbai aiškiai silpnesnis',
  'small: fast, poor for Lithuanian': 'small: greitas, lietuvių kalbai prastas',
  'distil-large-v3.5: fast, English only': 'distil-large-v3.5: greitas, tik anglų kalbai',
  'agirdi: turbo tuned on 10,000 hours of Lithuanian; fewest errors on phone calls, writes without capitals or punctuation':
    'agirdi: turbo, pritaikytas 10 000 valandų lietuvių kalbos įrašų; mažiausiai klaidų telefono pokalbiuose, rašo be didžiųjų raidžių ir skyrybos ženklų',
  'Keep corrected lines for training': 'Pataisytas eilutes saugoti mokymui',
  'Days. When people correct a transcript or mark it checked, its lines are kept with that bit of audio, to fine-tune the transcription model on. Usually longer than the recordings: say so in your privacy notice. 0 keeps none.':
    'Dienos. Kai darbuotojai pataiso transkripciją arba pažymi ją kaip patikrintą, jos eilutės išsaugomos su ta įrašo dalimi, kad jomis būtų galima apmokyti transkribavimo modelį. Paprastai saugoma ilgiau nei įrašai: nurodykite tai savo privatumo pranešime. 0 – nesaugoti.',
  'Nothing kept yet.': 'Kol kas nieko neišsaugota.',
  // {lines}: "3 eilutės"; {calls}: "iš 2 skambučių".
  'Kept so far: {lines} {calls} ({minutes} min of speech), {corrected} of them corrected.':
    'Kol kas išsaugota: {lines} {calls} ({minutes} min kalbos), iš jų pataisyta: {corrected}.',
  '{n} lines': { one: '{n} eilutė', few: '{n} eilutės', other: '{n} eilučių' },
  'from {n} calls': { one: 'iš {n} skambučio', few: 'iš {n} skambučių', other: 'iš {n} skambučių' },
  'Model per language': 'Modelis kiekvienai kalbai',
  'Empty uses the model above. A Whisper model tuned for one language can be better: for Lithuanian, agirdi.':
    'Tuščias langelis – naudojamas aukščiau pasirinktas modelis. Vienai kalbai pritaikytas Whisper modelis gali būti geresnis: lietuvių kalbai – agirdi.',

  // General: AI call review.
  'AI call review': 'DI pokalbių vertinimas',
  'After a sales call is transcribed, a language model reviews it: a summary, the likely outcome, why the sale didn’t happen and what to do differently, each point linked to the moment in the call. Off until you choose a model.':
    'Kai pardavimų skambutis transkribuojamas, kalbos modelis jį įvertina: santrauka, tikėtinas rezultatas, kodėl pardavimas neįvyko ir ką daryti kitaip, kiekvienas teiginys susietas su pokalbio vieta. Išjungta, kol nepasirenkate modelio.',
  'Another model (OpenAI-compatible)': 'Kitas modelis (suderinamas su OpenAI)',
  'Empty: {model}': 'Tuščia: {model}',
  'As OpenAI names it, e.g. gpt-5': 'Kaip jį vadina OpenAI, pvz., gpt-5',
  'As the endpoint names it': 'Kaip jį vadina paslauga',
  Endpoint: 'Paslaugos adresas',
  'e.g. {example}': 'pvz., {example}',
  'Transcripts are sent to {provider} to be reviewed, so they leave your server. Check the provider’s data terms before you turn this on.':
    'Transkripcijos siunčiamos vertinti teikėjui {provider}, todėl jos palieka jūsų serverį. Prieš įjungdami patikrinkite teikėjo duomenų tvarkymo sąlygas.',
  'Transcripts are sent to this endpoint to be reviewed. If it runs elsewhere, they leave your server.':
    'Transkripcijos siunčiamos vertinti šiuo adresu. Jei paslauga veikia kitur, jos palieka jūsų serverį.',
  'Recordings are never sent.': 'Įrašai niekada nesiunčiami.',
  'Hide personal data before sending: phone numbers, email and postal addresses, card and account numbers, personal codes':
    'Prieš siunčiant paslėpti asmens duomenis: telefono numerius, el. pašto ir pašto adresus, kortelių ir sąskaitų numerius, asmens kodus',
  'Reviews are written in': 'Vertinimų kalba',
  'Shortest call reviewed': 'Trumpiausias vertinamas skambutis',
  'One conversation spans': 'Vienas pokalbis apima',
  'Days: calls with the same number this close are also reviewed together': 'Dienos: skambučiai su tuo pačiu numeriu per tiek dienų vertinami ir kartu',
  // The choices below are Nobody / Agents / Agents and region managers.
  'Hide personal data in transcripts for': 'Kas transkripcijose nemato asmens duomenų',
  'On screen. Admins always see the full text.': 'Ekrane. Administratoriai visada mato visą tekstą.',
  Agents: 'Agentai',
  'Agents and region managers': 'Agentai ir regionų vadovai',
  Scorecard: 'Vertinimo kortelė',
  'Optional. Each call is scored 1–5 on these, for coaching. Changing it starts a new version; older reviews keep theirs.':
    'Neprivaloma. Pagal šiuos kriterijus kiekvienas skambutis įvertinamas balu nuo 1 iki 5, kad būtų lengviau ugdyti darbuotojus. Pakeitus kortelę pradedama nauja versija; ankstesni vertinimai išlaiko savąją.',
  'e.g. Finds out the customer’s needs': 'pvz., Išsiaiškina kliento poreikius',
  Criterion: 'Kriterijus',
  'What good looks like': 'Kaip atrodo geras rezultatas',
  Description: 'Aprašymas',
  'Remove the criterion': 'Pašalinti kriterijų',
  'Add a criterion': 'Pridėti kriterijų',
  'This month': 'Šį mėnesį',
  '{used}% of the monthly AI budget used': 'Išnaudota {used} % mėnesio DI biudžeto',
  '{used} of {budget} tokens. Reviews pause when the budget is used up; your provider sets it.':
    'Išnaudota {used} iš {budget} žetonų. Išnaudojus biudžetą, vertinimai sustabdomi; biudžetą nustato jūsų paslaugų teikėjas.',
  'Reasons sales are lost': 'Pardavimų praradimo priežastys',
  'The categories reviews sort reasons and objections into. When nothing fits, the AI suggests a new one for you to accept.':
    'Kategorijos, į kurias vertinimuose skirstomos priežastys ir prieštaravimai. Kai netinka nė viena, DI pasiūlo naują, kurią galite priimti.',
  'Suggested by the AI': 'DI pasiūlymai',
  Accept: 'Priimti',
  Reject: 'Atmesti',
  '{n} uses': { one: '{n} panaudojimas', few: '{n} panaudojimai', other: '{n} panaudojimų' },
  'Archive {name}': 'Archyvuoti: {name}',
  'Archive: no longer offered to the AI': 'Archyvuoti: DI jos nebesiūlys',
  'What it means': 'Ką ji reiškia',
  'Add a category': 'Pridėti kategoriją',
  'Points marked wrong': 'Klaidingais pažymėti teiginiai',
  Someone: 'Kažkas',
  ': “{note}”': ': „{note}“',

  // Carriers.
  '+370 5 200 0101 (with +)': '+370 5 200 0101 (su +)',
  '370 5 200 0101 (without +)': '370 5 200 0101 (be +)',
  '00370 5 200 0101 (with 00)': '00370 5 200 0101 (su 00)',
  // A carrier's status, and SmartOn's (Not connected is in phone).
  Connected: 'Prijungtas',
  Connecting: 'Jungiamasi',
  Checking: 'Tikrinama',
  'Remove the carrier {name}?': 'Pašalinti ryšio operatorių {name}?',
  'The phone companies that carry your calls to and from ordinary phone numbers (SIP trunks).':
    'Telefono ryšio bendrovės, perduodančios jūsų skambučius į įprastus telefono numerius ir iš jų (SIP linijos).',
  'Add carrier': 'Pridėti ryšio operatorių',
  'No carriers yet': 'Ryšio operatorių dar nėra',
  'Add the SIP trunk details your carrier gave you, then add your numbers.':
    'Įveskite SIP linijos duomenis, kuriuos jums pateikė ryšio operatorius, tada pridėkite savo numerius.',
  Carrier: 'Ryšio operatorius',
  'Connects by': 'Jungimosi būdas',
  // {name}: the SIP login.
  'Account {name}': 'Paskyra {name}',
  'Address ({count})': 'Adresai ({count})',
  'Actions for {name}': 'Veiksmai: {name}',
  'Remove or move its numbers first': 'Pirmiausia pašalinkite arba perkelkite jo numerius',
  'Carriers that recognise you by address need to send your calls to {host} (SIP over UDP). Calls from addresses not listed on a carrier here are refused.':
    'Ryšio operatoriai, kurie jus atpažįsta pagal adresą, jūsų skambučius turi siųsti į {host} (SIP per UDP). Skambučiai iš adresų, nenurodytų prie jokio čia esančio ryšio operatoriaus, atmetami.',
  'Edit {name}': 'Redaguoti: {name}',
  'Yours to choose, e.g. Zadarma Lithuania': 'Pasirinkite patys, pvz., Zadarma Lithuania',
  'Carrier company': 'Operatoriaus bendrovė',
  Country: 'Šalis',
  'Numbers it sends without a country code are read as this country’s': 'Numeriai, kuriuos jis atsiunčia be šalies kodo, laikomi šios šalies numeriais',
  'Signing in with an account': 'Prisijungimas paskyra',
  'Recognising our address (IP)': 'Atpažinimas pagal mūsų adresą (IP)',
  Server: 'Serveris',
  'From the carrier, e.g. sip.zadarma.com': 'Nurodo ryšio operatorius, pvz., sip.zadarma.com',
  'Outbound proxy (optional)': 'Tarpinis serveris (neprivaloma)',
  'Only if the carrier gives one. Sign-in and calls are sent through it.': 'Tik jei ryšio operatorius jį nurodo. Prisijungimas ir skambučiai siunčiami per jį.',
  'Account name': 'Paskyros vardas',
  'The SIP login': 'SIP prisijungimo vardas',
  'The SIP password. It is never shown again.': 'SIP slaptažodis. Jis daugiau niekada nerodomas.',
  'Numbers we call are sent as': 'Skambinamų numerių formatas',
  'From user (optional)': 'From naudotojas (neprivaloma)',
  'Only if the carrier asks for one in the From header': 'Tik jei ryšio operatorius prašo jo From antraštėje',
  'From domain (optional)': 'From domenas (neprivaloma)',
  'Only if the carrier asks, e.g. this server’s address': 'Tik jei ryšio operatorius prašo, pvz., šio serverio adresas',
  'Carrier addresses': 'Ryšio operatoriaus adresai',
  'Where the carrier sends your calls from: addresses or ranges, e.g. 185.45.152.0/24. Other addresses are refused.':
    'Iš kur ryšio operatorius siunčia jūsų skambučius: adresai arba intervalai, pvz., 185.45.152.0/24. Kiti adresai atmetami.',
  'Save changes': 'Išsaugoti pakeitimus',
  'Type an address and press Enter': 'Įveskite adresą ir paspauskite Enter',
  'Add a carrier address': 'Pridėti ryšio operatoriaus adresą',

  // Numbers.
  'Remove {number}? Calls to it will no longer reach anyone.': 'Pašalinti {number}? Skambučiai šiuo numeriu niekam nebebus perduodami.',
  'Phone numbers from your carriers, and where each leads: a person, a queue or a call flow. A person’s number is also what customers see when they call.':
    'Telefono numeriai iš jūsų ryšio operatorių ir kur veda kiekvienas: darbuotojui, į eilę ar į skambučių scenarijų. Darbuotojo numerį taip pat mato klientai, kai jis jiems skambina.',
  'Add number': 'Pridėti numerį',
  // {link}: "pridėkite savo ryšio operatorių" (Add your carrier).
  'Numbers come from a carrier. {link} first.': 'Numeriai gaunami iš ryšio operatoriaus. Pirmiausia {link}.',
  'Add your carrier': 'pridėkite savo ryšio operatorių',
  'No numbers yet': 'Numerių dar nėra',
  'Add the numbers your carrier gave you, and choose who each one rings.': 'Pridėkite numerius, kuriuos jums suteikė ryšio operatorius, ir pasirinkite, kam skambės kiekvienas.',
  Rings: 'Kam skamba',
  'Queue: {name}': 'Eilė: {name}',
  'Flow: {name}': 'Scenarijus: {name}',
  Shared: 'Bendras',
  'Calls out use the caller’s own number. People without one call out with their region’s shared number; without that, they can call colleagues only.':
    'Skambučiams į išorę naudojamas paties skambinančiojo numeris. Neturintys savo numerio skambina bendru savo regiono numeriu; jei ir jo nėra, gali skambinti tik kolegoms.',
  'With the country code, e.g. +370 5 200 0101': 'Su šalies kodu, pvz., +370 5 200 0101',
  'A person, a queue, a call flow, or nobody: a shared number is the region’s, and people without their own number call out with it':
    'Darbuotojas, eilė, skambučių scenarijus arba niekas: bendras numeris priklauso regionui, juo į išorę skambina savo numerio neturintys darbuotojai',
  'Shared number of the region': 'Bendras regiono numeris',
  '{name} (not published)': '{name} (nepaskelbtas)',
  '{name} (ext. {extension}, all regions)': '{name} (vid. nr. {extension}, visi regionai)',
  '{name} (ext. {extension})': '{name} (vid. nr. {extension})',
  'Label (optional)': 'Žymė (neprivaloma)',
  'For your own reference, e.g. Sales line': 'Jūsų pačių reikmėms, pvz., Pardavimų linija',

  // SmartOn.
  'Calls on your customers in SmartOn, sales calls as sales events, and calling from SmartOn.':
    'Skambučiai jūsų klientų kortelėse SmartOn, pardavimų skambučiai kaip pardavimo įvykiai ir skambinimas iš SmartOn.',
  'Disconnect SmartOn? Calls stop going to SmartOn, and SmartOn can’t start calls here.':
    'Atjungti SmartOn? Skambučiai nebebus siunčiami į SmartOn, o SmartOn nebegalės pradėti skambučių čia.',
  Connection: 'Prijungimas',
  'Not reachable': 'Nepasiekiamas',
  // SmartOn's own menu is in Lithuanian: NUSTATYMAI → Integrations → API raktai.
  'In SmartOn, open Settings → Integrations → API keys and create a key that may use {product}. Then enter your company’s SmartOn address and the key here.':
    'SmartOn atidarykite NUSTATYMAI → Integrations → API raktai ir sukurkite raktą, kuriuo galima naudoti {product}. Tada čia įveskite savo įmonės SmartOn adresą ir raktą.',
  'SmartOn address': 'SmartOn adresas',
  'Leave empty to keep the saved key.': 'Palikite tuščią, kad liktų išsaugotas raktas.',
  Change: 'Keisti',
  Disconnect: 'Atjungti',
  Connect: 'Prijungti',
  'Sales calls and people': 'Pardavimų skambučiai ir darbuotojai',
  // {salesEvent}: "pardavimo įvykiu" (sales event).
  'Calls with SmartOn customers go to SmartOn. An answered call becomes a {salesEvent} when it came through a sales line or a salesperson took or made it. Any other call can be saved as one from SmartOn’s pop-up.':
    'Skambučiai su SmartOn klientais siunčiami į SmartOn. Atsilieptas skambutis tampa {salesEvent}, kai jis atėjo per pardavimų liniją arba jį priėmė ar atliko pardavėjas. Bet kurį kitą skambutį galima išsaugoti kaip pardavimo įvykį iš SmartOn kortelės.',
  'sales event': 'pardavimo įvykiu',
  'Sales event type': 'Pardavimo įvykio tipas',
  'What calls become in SmartOn.': 'Kuo skambučiai tampa SmartOn.',
  'Phone call (SmartOn’s)': 'Telefono skambutis (SmartOn tipas)',
  'Sales lines': 'Pardavimų linijos',
  'No queues yet.': 'Eilių dar nėra.',
  'No people yet': 'Darbuotojų dar nėra',
  Person: 'Darbuotojas',
  'In SmartOn': 'SmartOn paskyra',
  Salesperson: 'Pardavėjas',
  '{name} in SmartOn': '{name}: SmartOn paskyra',
  'Not linked': 'Nesusieta',
  'Not in SmartOn any more': 'Nebėra SmartOn',
  '{name} is a salesperson': '{name} yra pardavėjas',
  'People linked to SmartOn get its pop-ups when their phone rings, and their calls show who took them.':
    'Su SmartOn susieti darbuotojai gauna jo korteles, kai skamba jų telefonas, o jų skambučiuose matyti, kas atsiliepė.',
  'Saved here, but SmartOn couldn’t be told the sales event type: {error}': 'Išsaugota čia, bet SmartOn nepavyko perduoti pardavimo įvykio tipo: {error}',
  // Table columns (Carriers, Numbers).
  Provider: 'Tiekėjas',
  Address: 'Adresas',
  Label: 'Žymė',
};
